export const PILL_COLORS = {

  reactionYes: { color: "#b70000", bg: "#ffe8e8", border: "#b70000" },

  reactionNo: { color: "#006546", bg: "#e7efeb", border: "#006546" },

  reactionUnknown: { color: "#26252c", bg: "#f1f1f3", border: "#d9d8df" },

  method: { color: "#26252c", bg: "#f1f1f3", border: "#d9d8df" },

  site: { color: "#92400e", bg: "#fef3c7", border: "#fbbf24" },

  sentYes: { color: "#006546", bg: "#e7efeb", border: "#006546" },

  sentNo: { color: "#26252c", bg: "#f1f1f3", border: "#d9d8df" },

  genderMale: { color: "#1e40af", bg: "#dbeafe", border: "#3b82f6" },

  genderFemale: { color: "#b86b7a", bg: "#fce7eb", border: "#e8a8b8" },

  genderUnknown: { color: "#1f2937", bg: "#f3f4f6", border: "#6b7280" },

  deceased: { color: "#b70000", bg: "#ffe8e8", border: "#b70000" },

  docNew: { color: "#2563EB", bg: "#EFF6FF", border: "#2563EB" },
  docOpen: { color: "#01533B", bg: "#E7EFEB", border: "#01533B" },
  docInProgress: { color: "#B45309", bg: "#FEF3C7", border: "#B45309" },
  docReviewed: { color: "#7C3AED", bg: "#F3E8FF", border: "#7C3AED" },
  docClosed: { color: "#6B7280", bg: "#F3F4F6", border: "#6B7280" },
  docUploaded: { color: "#059669", bg: "#ECFDF5", border: "#059669" },
  docSystemGenerated: { color: "#4338CA", bg: "#EEF2FF", border: "#4338CA" },
  docReferral: { color: "#5a4fcf", bg: "#e7e4ff", border: "#5a4fcf" },
  docUnknown: { color: "#9CA3AF", bg: "#F7F7F8", border: "#9CA3AF" },

  statusNoStatus: { color: "#6B7280", bg: "#F3F4F6", border: "#D1D5DB" },
  statusAcknowledged: { color: "#006546", bg: "#e7efeb", border: "#006546" },
  statusSent: { color: "#006546", bg: "#e7efeb", border: "#006546" },
  statusError: { color: "#b70000", bg: "#ffe8e8", border: "#b70000" },
  statusWarning: { color: "#92400e", bg: "#fef3c7", border: "#fbbf24" },
  statusSuccess: { color: "#006546", bg: "#e7efeb", border: "#006546" },
  statusPending: { color: "#1d4ed8", bg: "#dbeafe", border: "#3b82f6" },

  paymentPaid: { color: "#1d4ed8", bg: "#dbeafe", border: "#3b82f6" },
  paymentUnpaid: { color: "#b70000", bg: "#ffe8e8", border: "#b70000" },
  paymentPartial: { color: "#92400e", bg: "#fef3c7", border: "#fbbf24" },
};
